import type { NotificationResponseName } from "@shared/api/websocket"
import {
	type NotificationResponseInputBody,
	notificationResponse,
} from "@/shared/api/generated-social"
import { settleNotification } from "@/shared/api/websocket"
import type { NotificationRecord } from "../model/types"

export type NotificationResponseStatus = NotificationResponseInputBody["status"]

export type NotificationResponseSource = NonNullable<
	NotificationResponseInputBody["source"]
>

// Reports the user's response to a notification. The server records it and
// stops replaying the notification on reconnect. Fire-and-forget: the UI
// neither waits for the request nor fails on a network error.
//
// A popup the app raised itself carries no row — there is nothing to answer, so
// the call is a no-op rather than something every caller has to guard. A record
// that carries no name is answered without one.
export function sendNotificationResponse(
	name: NotificationResponseName | null,
	status: NotificationResponseStatus,
	notificationId: number | null,
	source: NotificationResponseSource = "app",
): void {
	if (notificationId === null) return
	settleNotification(notificationId)
	const body: NotificationResponseInputBody = { status, source }
	if (name !== null) body.name = name
	notificationResponse({
		path: { notification_id: notificationId },
		body,
	}).catch(() => {})
}

export function answerNotification(
	record: NotificationRecord,
	status: NotificationResponseStatus,
): void {
	if (record.origin === "local") return

	if ("name" in record) {
		sendNotificationResponse(record.name, status, record.notificationId)
	} else {
		sendNotificationResponse(null, status, record.notificationId)
	}
}
